import React, { FC } from 'react';
import { Chip, CircularProgress, makeStyles } from '@material-ui/core';

import { useGameListItemData } from './useGameListItemData';
import { Airing, Fer, Status } from '../../utils/types';

const useStyles = makeStyles(() => ({
	clipList: {
		listStyleType: 'none',
		padding: 0,
		margin: 0
	},
	clipListItem: {
		height: 32,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 3,
		fontSize: '0.8rem',
		color: '#4b5563'
	},
	ferSpacer: {
		height: 32,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 3,
		marginTop: 14,
		fontSize: '0.8rem',
		color: '#9ca3af'
	},
	zeroClipDanger: {
		backgroundColor: '#d32f2f',
		color: '#fff'
	}
}));

type Props = {
	gameId: string;
	gameStatus?: string | null;
};

const GameListItemClips: FC<Props> = ({ gameId, gameStatus }) => {
	const classes = useStyles();
	const { airings, fers, loading, error, clipsForAiring } = useGameListItemData(gameId, gameStatus);

	if (loading) return <CircularProgress size={16} />;
	if (error) return <>-</>;
	if (airings.length === 0 && fers.length === 0) return <>N/A</>;

	const renderClipRow = (airing: Airing): JSX.Element => {
		const clips = clipsForAiring(airing);
		const showZeroDangerChip = clips === 0 && (gameStatus === Status.LIVE || gameStatus === Status.COMPLETED);

		return (
			<li key={`clip_${airing.id}`} className={classes.clipListItem}>
				{clips > 0 ? <Chip label={clips} size='small' /> : null}
				{showZeroDangerChip ? <Chip label={0} size='small' className={classes.zeroClipDanger} /> : null}
			</li>
		);
	};

	const renderFerSpacer = (fer: Fer): JSX.Element => <li key={`fer_clip_${fer.ferId}`} className={classes.ferSpacer} />;

	return (
		<ul className={classes.clipList}>
			{airings.map((airing) => renderClipRow(airing))}
			{fers.map((fer) => renderFerSpacer(fer))}
		</ul>
	);
};

export default GameListItemClips;
